module.exports = __webpack_public_path__ + "img/class_L3.a9c16aa6.jpg";